export enum IDashboardActionTypes {
  GET_POLITICAL_GROUP = "@@dashboard/GET_POLITICAL_GROUP",
  GET_POLITICAL_GROUP_SUCCESS = "@@dashboard/GET_POLITICAL_GROUP_SUCCESS",
  GET_POLITICAL_GROUP_ERROR = "@@dashboard/GET_POLITICAL_GROUP_ERROR",

  GET_DASHBOARD = "@@dashboard/GET_DASHBOARD",
  GET_DASHBOARD_SUCCESS = "@@dashboard/GET_DASHBOARD_SUCCESS",
  GET_DASHBOARD_ERROR = "@@dashboard/GET_DASHBOARD_ERROR",

  BUILD_COLUMNS = "@@dashboard/BUILD_COLUMNS",
  BUILD_DATA_MONTH_HMS = "@@dashboard/BUILD_DATA_MONTH_HMS",
  BUILD_DATA_MONTH_PERCENT = "@@dashboard/BUILD_DATA_MONTH_PERCENT",
  BUILD_DATA_HMS = "@@dashboard/BUILD_DATA_HMS",
  BUILD_DATA_PERCENT = "@@dashboard/BUILD_DATA_PERCENT",
  SET_DISPLAY_FORMAT = "@@dashboard/SET_DISPLAY_FORMAT",

  GET_DASHBOARD_DETAIL = "@@dashboard/GET_DASHBOARD_DETAIL",
  GET_DASHBOARD_DETAIL_SUCCESS = "@@dashboard/GET_DASHBOARD_DETAIL_SUCCESS",
  GET_DASHBOARD_DETAIL_ERROR = "@@dashboard/GET_DASHBOARD_DETAIL_ERROR",

  GET_DATE_CLOTURE = "@@user/GET_DATE_CLOTURE",
  GET_DATE_CLOTURE_SUCCESS = "@@user/GET_DATE_CLOTURE_SUCCESS",

  RESET_DATA = "@@dashboard/RESET_DATA",
  INITIALIZE_DATA = "@@dashboard/INITIALIZE_DATA",
  GET_EMISSION_AUTOCOMPLETE = "@@dashboard/GET_EMISSION_AUTOCOMPLETE",
  GET_EMISSION_AUTOCOMPLETE_SUCCESS = "@@dashboard/GET_EMISSION_AUTOCOMPLETE_SUCCESS",
  GET_EMISSION_AUTOCOMPLETE_ERROR = "@@dashboard/GET_EMISSION_AUTOCOMPLETE_ERROR",
  CLEAR_EMISSION_LIST = "@@dashboard/CLEAR_EMISSION_LIST",
}

export const randomImages: any = {
  175710: require("../../Assets/175710.png"),
  175711: require("../../Assets/175711.png"),
  175712: require("../../Assets/175712.png"),
  182048: require("../../Assets/182048.png"),
  557: require("../../Assets/557.png"),
  76770: require("../../Assets/76770.png"),
  169078: require("../../Assets/169078.png"),
};

export interface ISubGroupList {
  Header: any;
  Footer?: any;
  accessor?: string;
  id?: any;
  cid?: number | undefined;
  show?: boolean;
  getProps?: () => void;
}
export interface IGroupList {
  Header: any;
  Footer?: any;
  headerStyle?: any;
  id?: any;
  accessor?: string;
  cid?: number | undefined;
  columns: ISubGroupList[];
  getProps?: () => void;
}
export interface IPoliticalGroup {
  link_id: number;
  political_group_color: number;
  political_group_id: number;
  political_group_index: string;
  political_group_name: string;
  political_regime_color: number;
  political_regime_id: number;
  political_regime_index: string;
  political_regime_name: string;
}
export interface ITotalPoliticalGroup {
  display_hms: string;
  libelle_row: string;
  milliseconds: number;
  percent: string;
  percent_base100: string;
  political_regime_id: number;
}
export interface IPeriodSimple {
  display_hms: string;
  libelle_row: string;
  milliseconds: number;
  percent: string;
  percent_base100: string;
}
export interface IMonth {
  [month_id: string]: IPeriodSimple;
}
export interface IQuarter {
  [quarter_id: string]: IPeriodSimple;
}
export interface ISemester {
  [semester_id: string]: IPeriodSimple;
}
export interface IYear {
  [year_id: string]: IPeriodSimple;
}
export interface IDays {
  [day: string]: IPeriodSimple;
}
export interface ICumul {
  days: IDays;
  month: IMonth;
  quarter: IQuarter;
  semester: IQuarter;
  year: IQuarter;
}
export interface IPoliticalGroupSimple {
  cumuls: ICumul;
  political_group_id: number;
  political_group_name: string;
}
export interface IPoliticalGroupId {
  readonly [politicalGroupId: string]: IPoliticalGroupSimple;
}
export interface IPoliticalRegime {
  color: number;
  id: number;
  index: string;
  name: string;
  cumuls: ICumul;
  political_group_ids: IPoliticalGroupId;
  political_regime_id: number;
  political_regime_name: string;
}
export interface IPoliticalRegimeId {
  readonly [politicalRegimeId: string]: IPoliticalRegime;
}
export interface IResults {
  list_days?: any;
  political_regime_ids: IPoliticalRegime[];
  search_libelle: any;
  totals: any;
}
export type IDateType =
  | "annual"
  | "semester"
  | "quarter"
  | "month"
  | "calendar";
export type IDisplayFormat = "duration" | "percent";

//export const endDate = getDateOneDayBeforeTodayHourZero(getDateTodayHourZero())

export const monthsOfYear: any = [];
monthsOfYear[0] = "Janvier";
monthsOfYear[1] = "Février";
monthsOfYear[2] = "Mars";
monthsOfYear[3] = "Avril";
monthsOfYear[4] = "Mai";
monthsOfYear[5] = "Juin";
monthsOfYear[6] = "Juillet";
monthsOfYear[7] = "Août";
monthsOfYear[8] = "Septembre";
monthsOfYear[9] = "Octobre";
monthsOfYear[10] = "Novembre";
monthsOfYear[11] = "Décembre";

export interface IFiltersDetail {
  political_regime_ids: number[];
  political_group_ids: number[];
  media_ids: number[];
  program_type_ids: number[];
  program_editor_ids: number[];
  time_slot_start: string;
  time_slot_end: string;
  date_start: Date;
  date_end: Date;
  political_group_id?: number;
  study_type_id: number;
  program_name?: string;
}
export const percentHiddenColumns: number[] = [121, 183];
export interface IFilters {
  media_ids: number[];
  program_type_ids: number[];
  media_str: string[];
  program_type_str: string[];
  program_editors_ids: number[];
  program_editors_str: string[];
  time_slot_start: string;
  time_slot_end: string;
  date_type: IDateType;
  date_start: Date;
  date_end: Date;
  display_format: IDisplayFormat;
  study_type_id?: number;
  program_name?: string;
}
export interface IDetail {
  broadcast_id: number;
  broadcast_libelle: string;
  date_end: string;
  date_start: string;
  day: string;
  duration_hms: string;
  duration_s: number;
  emission_type_id: number;
  emission_type_name: string;
  function: string;
  media_id: number;
  media_name: string;
  person_id: number;
  person_name: string;
  political_group_id: number;
  political_group_name: string;
  political_regime_id?: number;
  political_regime_name?: string;
  program_editor_id: number;
  program_editor_name: string;
  time: string;
}
export interface IDashboardState {
  readonly politicalRegimeList: IPoliticalRegime[];
  readonly politicalGroupList: IPoliticalGroup[];
  readonly initialPoliticalGroupID: number[];
  readonly initialPoliticalGroupStr: string[];
  readonly filters: IFilters;
  readonly detailsFilters: IFiltersDetail;
  readonly selectedName: string;
  readonly selectedDate: string;
  readonly dashboardResults: IResults | null;
  columns: IGroupList[] | null;
  data: any;
  dataHms: any;
  dataPercent: any;
  months: string[] | null;
  isLoading: boolean;
  readonly dashboardDetail: IDetail[] | null;
  isLoadingDetail: boolean;
  readonly dateCloture: Date | null;
  readonly loadingDateCloture: boolean;
  readonly emissions: string[];
  readonly isEmissionAutocompleteLoading: boolean;
}
